export { default as Image } from './Image';
import { ImageProps as _ImageProps } from './Image';
export type ImageProps = _ImageProps;
